var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousePennyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.003,
    height: 47,
    viewBox: "0 0 49.003 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0090ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.497 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-230 -113)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M265.5,132.5a14,14,0,1,1-14,14A14,14,0,0,1,265.5,132.5Zm0,3a11,11,0,1,0,11,11A11,11,0,0,0,265.5,135.5Zm0,3a1.5,1.5,0,0,1,1.493,1.356L267,140v.5h1a1.5,1.5,0,0,1,.144,2.993L268,143.5h-3.75a.75.75,0,0,0-.1,1.493l.1.007h2.5a3.75,3.75,0,0,1,.251,7.492V153a1.5,1.5,0,0,1-2.993.144L264,153v-.5h-1a1.5,1.5,0,0,1-.144-2.993L263,149.5h3.75a.75.75,0,0,0,.1-1.493l-.1-.007h-2.5a3.75,3.75,0,0,1-.25-7.492V140A1.5,1.5,0,0,1,265.5,138.5Zm-18.071-24.678.113.1,14.5,14a1.5,1.5,0,0,1-.909,2.574L261,130.5h-2.5v.5a1.5,1.5,0,0,1-1.356,1.493L257,132.5a1.5,1.5,0,0,1-1.493-1.356L255.5,131v-2a1.5,1.5,0,0,1,1.356-1.493L257,127.5h.287L246.5,117.085,235.712,127.5H236a1.5,1.5,0,0,1,1.493,1.356l.007.144v10.5h5v-5a4,4,0,0,1,8-.2l0,.2V141a1.5,1.5,0,0,1-1.356,1.493L249,142.5H236a1.5,1.5,0,0,1-1.493-1.356L234.5,141V130.5H232a1.5,1.5,0,0,1-1.134-2.483l.092-.1,14.5-14A1.5,1.5,0,0,1,247.429,113.822ZM246.5,133.5a1,1,0,0,0-.993.883l-.007.117v5h2v-5A1,1,0,0,0,246.5,133.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousePennyIcon);
export default __webpack_public_path__ + "static/media/house-penny-icon.d5ac25753ee827a5499c3a978b79b6db.svg";
export { ForwardRef as ReactComponent };